import { Field } from "formik";
import React from "react";

function CheckboxGroup({ questionName, name, options, handleChange, isMandatory }) {
  return (
    <>
      {!!questionName && (
        <h2 className="card_medicine_heading">
          {questionName}
          {isMandatory && <span>*</span>}
        </h2>
      )}

      <div className="idp_radio_blk">
        <Field name={name}>
          {({ field, form }) => (
            <>
              {options?.map((option, ind) => {
                const checked = field.value?.includes(option.id);
                return (
                  <div className="idp_radio_group" key={ind}>
                    <input
                      type="checkbox"
                      id={`${name}-${ind}`}
                      name={name}
                      value={option.id}
                      checked={checked}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        let newValue = Array.isArray(field.value) ? [...field.value] : [];
                        if (isChecked) {
                          newValue.push(option.id);
                        } else {
                          newValue = newValue.filter((v) => v !== option.id);
                        }
                        form.setFieldValue(name, newValue);
                        if (handleChange) handleChange(e);
                      }}
                    />
                    <label htmlFor={`${name}-${ind}`}>{option.name}</label>
                  </div>
                );
              })}
            </>
          )}
        </Field>
      </div>
    </>
  );
}

export default CheckboxGroup;
